import { PayloadAction } from '@reduxjs/toolkit'
import { setSettingsValue } from '../../../components/common/utility/helpers'
import { DashboardState, SettingsState } from '../settings.slice'

export const setDashboardChartReducer = (
    state: SettingsState,
    action: PayloadAction<DashboardState>
): void => {
    const { payload } = action
    state.dashboard = payload || {}

    setSettingsValue('dashboard', payload || {})
}
